module.exports = __webpack_public_path__ + "static/img/1vr2.5d343973.png";